import React, { useState } from 'react';
import { WelcomeStep } from '../components/patient-upload/WelcomeStep';
import { UploadStep } from '../components/patient-upload/UploadStep';
import { ResultStep } from '../components/patient-upload/ResultStep';
import { Check } from 'lucide-react';
type Step = 1 | 2 | 3;
export function PatientUpload() {
  const [currentStep, setCurrentStep] = useState<Step>(1);
  const handleNext = () => {
    if (currentStep < 3) {
      setCurrentStep(prev => prev + 1 as Step);
    }
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  return <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center p-4 sm:p-8 font-sans" data-id="element-182">
      {/* Mobile Device Frame */}
      <div className="relative w-full max-w-[390px] h-[844px] bg-white rounded-[3rem] shadow-2xl overflow-hidden border-[12px] border-[#1E293B] flex flex-col" data-id="element-183">
        {/* Fake iPhone Notch/Dynamic Island */}
        <div className="absolute top-0 inset-x-0 h-7 flex justify-center z-50" data-id="element-184">
          <div className="w-32 h-6 bg-[#1E293B] rounded-b-3xl" data-id="element-185"></div>
        </div>

        {/* Header / Stepper (Only show on steps 2 and 3) */}
        {currentStep > 1 && <div className="pt-12 pb-4 px-6 bg-white border-b border-[#e5e7eb] z-10" data-id="element-186">
            <div className="flex items-center justify-between relative" data-id="element-187">
              {/* Connecting Lines */}
              <div className="absolute top-4 left-6 right-6 h-0.5 bg-[#e5e7eb] -z-10" data-id="element-188"></div>
              <div className="absolute top-4 left-6 h-0.5 bg-[#b8a06a] -z-10 transition-all duration-500 ease-in-out" style={{
            width: currentStep === 3 ? '100%' : currentStep === 2 ? '50%' : '0%'
          }} data-id="element-189"></div>

              {/* Step 1: Welcome (Always done if we are here) */}
              <div className="flex flex-col items-center gap-2 bg-white px-2" data-id="element-190">
                <div className="w-8 h-8 rounded-full bg-[#b8a06a] flex items-center justify-center text-white shadow-sm" data-id="element-191">
                  <Check className="w-4 h-4 stroke-[3]" data-id="element-192" />
                </div>
                <span className="text-[10px] font-bold text-[#b8a06a] uppercase tracking-wider" data-id="element-193">
                  Welcome
                </span>
              </div>

              {/* Step 2: Upload */}
              <div className="flex flex-col items-center gap-2 bg-white px-2" data-id="element-194">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shadow-sm transition-colors duration-300 ${currentStep >= 2 ? currentStep > 2 ? 'bg-[#b8a06a] text-white' : 'bg-[#b8a06a] text-white ring-4 ring-[#b8a06a]/20' : 'bg-white border-2 border-[#e5e7eb] text-[#9ca3af]'}`} data-id="element-195">
                  {currentStep > 2 ? <Check className="w-4 h-4 stroke-[3]" data-id="element-196" /> : '2'}
                </div>
                <span className={`text-[10px] font-bold uppercase tracking-wider ${currentStep >= 2 ? 'text-[#b8a06a]' : 'text-[#9ca3af]'}`} data-id="element-197">
                  Upload
                </span>
              </div>

              {/* Step 3: Results */}
              <div className="flex flex-col items-center gap-2 bg-white px-2" data-id="element-198">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shadow-sm transition-colors duration-300 ${currentStep === 3 ? 'bg-[#b8a06a] text-white ring-4 ring-[#b8a06a]/20' : 'bg-white border-2 border-[#e5e7eb] text-[#9ca3af]'}`} data-id="element-199">
                  3
                </div>
                <span className={`text-[10px] font-bold uppercase tracking-wider ${currentStep === 3 ? 'text-[#b8a06a]' : 'text-[#9ca3af]'}`} data-id="element-200">
                  Results
                </span>
              </div>
            </div>
          </div>}

        {/* Content Area - Scrollable */}
        <div className="flex-1 overflow-hidden relative bg-white" data-id="element-201">
          {/* Use simple conditional rendering for steps to avoid complex animation logic for now */}
          <div className="absolute inset-0 h-full w-full" data-id="element-202">
            {currentStep === 1 && <WelcomeStep onNext={handleNext} data-id="element-203" />}
            {currentStep === 2 && <UploadStep onNext={handleNext} data-id="element-204" />}
            {currentStep === 3 && <ResultStep onReset={handleReset} data-id="element-205" />}
          </div>
        </div>

        {/* Fake Home Indicator */}
        <div className="h-8 bg-white flex items-center justify-center pb-2 z-10" data-id="element-206">
          <div className="w-1/3 h-1 bg-[#1a1a2e] rounded-full opacity-20" data-id="element-207"></div>
        </div>
      </div>
    </div>;
}